import { Maximize } from 'lucide-react';
import * as React from 'react';
import { SidelyBlack } from '../../../styles/global/css/Utils';
import { MapButton } from '../Map';

export default function MapFullScreenButton(props: { map }) {
	const [isFullscreen, setIsFullscreen] = React.useState(false);

	React.useEffect(() => {
		const onFullscreenChange = () => {
			setIsFullscreen(!!document.fullscreenElement);
		};
		document.addEventListener('fullscreenchange', onFullscreenChange);
		return () => {
			document.removeEventListener('fullscreenchange', onFullscreenChange);
		};
	}, []);

	return (
		<MapButton
			marginRight
			marginTop
			onClick={() => {
				if (!isFullscreen) {
					props.map.getDiv().firstChild.requestFullscreen();
				} else if (document.fullscreenElement) {
					document.exitFullscreen();
				}
			}}
		>
			<Maximize height={24} width={24} color={SidelyBlack} />
		</MapButton>
	);
}
